var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
    'vuw-search-overlay-active': _vm.searchActive || _vm.searchQuery.length > 0,
  }},[(_vm.error)?_c('error-messages-component',{staticClass:"vuw-mb-2",attrs:{"errors":[_vm.error]}}):_vm._e(),_c('form-component'),(!_vm.externalSearchActive)?_c('results-overlay-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }